export default {
  NORTH: 'north',
  NORTHWEST: 'north-west',
  NORTHEAST: 'north-east',
  SOUTH: 'south',
  SOUTHWEST: 'south-west',
  SOUTHEAST: 'south-east',
  WEST: 'west',
  EAST: 'east',
  DEFAULT: 'south-east',
};
